<div class="empty-placeholder py-5">
  <div class="media mb-3">
    @if (icon(); as iconValue) {
      <div class="icon-container" aria-hidden="true">
        <fa-icon [icon]="iconValue"></fa-icon>
      </div>
    } @else if (hasIllustration()) {
      <div class="illustration-container">
        <ng-content select="[emptyPlaceholderIllustration]"></ng-content>
      </div>
    }
  </div>

  <h5 class="title m-0">{{ title() }}</h5>
  <p class="text m-0">{{ text() }}</p>

  @if (hasActions()) {
    <div class="actions mt-4 gap-3">
      <ng-content select="[emptyPlaceholderActions]"></ng-content>
    </div>
  }
</div>
